export const ToolButton = ({ image, onClick, className }: { image: string; onClick: () => void, className?: string }) => {
  return (
    <button className={`w-8 h-8 my-auto rounded-md ${className}`} onClick={onClick}>
      <img src={image} alt="tool" />
    </button>
  );
};
